import { APP_INITIALIZER, Provider } from '@angular/core';
import { KeycloakService, KeycloakEventType } from 'keycloak-angular';
import { filter, switchMap } from 'rxjs/operators';
import { WhiteLabelConfigService } from 'src/app/white-label/white-label-config.service';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

export const appKeycloakProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: initializeKeycloak,
  multi: true,
  deps: [KeycloakService, AuthService, WhiteLabelConfigService],
};

function initializeKeycloak(
  keycloak: KeycloakService,
  authService: AuthService,
  whiteLabelConfigService: WhiteLabelConfigService,
): () => Promise<boolean> {
  const logoutRedirectUrl = whiteLabelConfigService.config.frontendConfigDto?.logoutRedirectUrl;
  keycloak.keycloakEvents$
    .pipe(
      filter(event => event.type === KeycloakEventType.OnTokenExpired),
      switchMap(() => keycloak.updateToken()),
    )
    .subscribe(
      hasTokenUpdated => {
        if (!hasTokenUpdated) {
          keycloak.logout(logoutRedirectUrl);
        }
      },
      () => keycloak.logout(logoutRedirectUrl),
    );

  return async () => {
    const res = await keycloak.init({
      config: {
        url: environment.keycloakBaseUrl,
        realm: environment.keycloakRealm,
        clientId: environment.keycloakClientId,
      },
      initOptions: {
        checkLoginIframe: false,
      },
    });

    authService.setAuthState(res);

    return res;
  }

}
